import { User, sendEmailVerification } from 'firebase/auth';

export class EmailVerificationService {
  
  /**
   * Send email verification to user
   */
  static async sendVerification(user: User): Promise<void> {
    try {
      await sendEmailVerification(user);
      console.log('✅ Verification email sent to:', user.email);
    } catch (error) {
      console.error('Error sending verification email:', error);
      throw error;
    }
  }

  /**
   * Check if user email is verified
   */
  static isEmailVerified(user: User): boolean {
    return user.emailVerified;
  }

  /**
   * Require email verification for MASTER users
   */
  static async requireVerificationForMaster(user: User, userRole: string): Promise<boolean> {
    if (userRole === 'MASTER' && !user.emailVerified) {
      console.warn('⚠️ MASTER user email not verified');
      return false;
    }
    return true;
  }

  /**
   * Reload user to check verification status
   */
  static async checkVerificationStatus(user: User): Promise<boolean> {
    await user.reload();
    return user.emailVerified;
  }

  /**
   * Resend verification email with rate limiting
   */
  static async resendVerification(user: User): Promise<void> {
    const lastSent = localStorage.getItem('last_verification_sent');
    const now = Date.now();
    
    if (lastSent && (now - parseInt(lastSent)) < 60000) { // 1 minute
      throw new Error('Please wait before requesting another verification email');
    }
    
    await this.sendVerification(user);
    localStorage.setItem('last_verification_sent', now.toString());
  }
}





